<script setup lang="ts">
defineProps<{
  numSlides?: number,
  sliderContents?: string
}>()
</script>

<template>
  <div class="bx-badge--slider-arrow">
    <svg class="icon icon-arrow_slider_prev">
      <use href="#arrow_pager-prev" />
    </svg>
  </div>
  <div class="bx-badge--slider-arrow bx-badge--slider-arrow-next">
    <svg class="icon icon-arrow_slider_next">
      <use href="#arrow_pager-next" />
    </svg>
  </div>
  <span class="bx-badge--image-count">
    <svg class="icon icon-layers">
      <use href="#layers" />
    </svg>
    {{ numSlides }} {{ sliderContents }}
  </span>
</template>
